import { useRef } from "preact/hooks";
import Button from "~/components/button.tsx";
import type { ModalProps } from "~/components/modal.tsx";
import Modal from "~/components/modal.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import ResetIcon from "~/components/icons/reset.tsx";
import HomeIcon from "~/components/icons/home-icon.tsx";
import UploadIcon from "../setup/image-confirm/upload-icon.tsx";
import classes from "./confirm-restart-modal.module.css";

type ConfirmRestartModalProps = Pick<ModalProps, "id"> & {
	readonly onReset: () => void;
	readonly onBackToUpload: () => void;
	readonly onBackToHomePage: () => void;
};

function ConfirmRestartModal({
	id,
	onReset,
	onBackToUpload,
	onBackToHomePage,
}: ConfirmRestartModalProps) {
	const t = useTranslator();
	const dialogRef = useRef<HTMLDialogElement>(null);
	return (
		<Modal id={id} size="small" dialogRef={dialogRef}>
			<div className={classes["buttons"]}>
				<Button
					type="button"
					onClick={() => {
						dialogRef.current?.close();
						onReset();
					}}
					variant="blue"
				>
					<ResetIcon />
					{t("Reset design")}
				</Button>
				<Button
					type="button"
					onClick={() => {
						dialogRef.current?.close();
						onBackToUpload();
					}}
					variant="black-line"
				>
					<UploadIcon />
					{t("Back to upload")}
				</Button>
				<Button
					type="button"
					onClick={() => {
						dialogRef.current?.close();
						onBackToHomePage();
					}}
					variant="black-line"
				>
					<HomeIcon size={24} />
					{t("Back to home")}
				</Button>
			</div>
		</Modal>
	);
}

export default ConfirmRestartModal;
